import styled from 'styled-components';
import Typography from '../../../../styles/Typography';

export const StyledTableWrapper = styled.div``;

export const StyledSearchForm = styled.form`
  width: 100%;
  max-width: 26rem;
  z-index: 10;
  ${({ theme }) =>
    theme.direction === 'rtl' ? 'margin-right: 2rem;' : 'margin-left: 2rem;'}
`;

export const StyledForm = styled.form`
  width: 100%;
`;

export const StyledTextareaDescription = styled(Typography).attrs({
  variant: 'caption',
})`
  color: var(--muted);
`;
